// extracted by mini-css-extract-plugin
export default {"collection__card":"collection-item_collection__card__2FD6z","left":"collection-item_left__EvtzR","image":"collection-item_image__1zyED","arrow":"collection-item_arrow__rHrPj"};